<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
import { toRaw, watchEffect } from 'vue';
import { useQuery } from '@tanstack/vue-query';

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useProductStore } from '@/store/product.store';

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  errorMessage,
  file,
  form_product_step_one,
  previewUrl,
  arraysStepOne,
  category_product,
  stepOneActive,
  stepTwoActive,
  descriptionPageProduct,
  dynamicExtraOptions,
  stepFourActive,
  stepThreeActive,
  titlePageProduct,
  isNewProduct,
  isReadProduct,
  productId,
  designation_product_filter,
  isUpdatedProduct,
  productVariantsList,
} from '@/refs/product.refs';
import { IconUploadCloud } from '@/assets/svg/common.svg';
import { useCategoryStore } from '@/store/category.store';
import { form, isLoaderLoginFormActivated } from '@/refs/login.form.refs';
import { formatPrice } from '@/utils/formatPrice';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { ProductMutation } from '@/mutations/product.mutation';
import type {
  ExtraMenuInterface,
  ExtraMenuUpdateInterface,
  IPoductBody,
  IProductImage,
  IUpdateProductBody,
} from '@/types/product.types';
import { isGlobalError, restaurantId } from '@/refs/common.refs';
import { useCommerceStore } from '@/store/commerce.store';
import { cleanBody } from '@/utils/cleanBody';
import { toDecimal } from '@/utils/toDecimal';
import { useTaxeStore } from '@/store/taxe.stsore';
const {
  handleCreateProduct,
  handleUploadImage,
  handleDeleteProduct,
  handleUpdateProduct,
} = ProductMutation();

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const productStore = useProductStore();
const categoryStore = useCategoryStore();
const commerceStore = useCommerceStore();
const taxeStore = useTaxeStore();

// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------
const {
  data: dataGetCommerces,
  isLoading: isLoadingGetCommerces,
  isError: isErrorGetCommerces,
  refetch: refectGetCommerces,
} = useQuery({
  queryKey: ['GetCommerces'],
  queryFn: () => commerceStore.getCommerces(),
});
const {
  data: dataGetCategories,
  isLoading: isLoadingGetCategories,
  isError: isErrorGetCategories,
  refetch: refectGetCategories,
} = useQuery({
  queryKey: ['GetCategories'],
  queryFn: () => categoryStore.getCategory(),
});

const {
  data: dataGetTaxeStore,
  isLoading: isLoadingGetdataGetTaxeStore,
  isError: isErrorGetdataGetTaxeStore,
  refetch: refectGetTaxeStore,
} = useQuery({
  queryKey: ['GetTaxeStore'],
  queryFn: () => taxeStore.getTaxe(),
});

// -------------------------------
// 🔹 Toutes les fonctions
// -------------------------------

// -------------------------------
// 🔹 Debugging (optionnel)
// -------------------------------
// watchEffect(() => {
//     console.log("Valeurs cochées :", productStore.datagetProduct);
// });

const HandleCheckedDesignation = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'firstField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};

const HandleCheckedPrice = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'secondField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};

const HandleCheckedTaxe = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'thirdField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
      console.log('Le champ est vide (aucune entrée à supprimer).');
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};
const resizeImageTo500 = (file: File): Promise<File> => {
  return new Promise((resolve) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;

      canvas.width = 500;
      canvas.height = 500;

      ctx.clearRect(0, 0, 500, 500);
      ctx.drawImage(img, 0, 0, 500, 500);

      canvas.toBlob((blob) => {
        const newFile = new File([blob!], file.name, {
          type: 'image/png',
        });
        resolve(newFile);
      }, 'image/png');
    };

    reader.readAsDataURL(file);
  });
};

const handleCheckDescription = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'sixthField';
  const index = arraysStepOne.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepOne.value.splice(index, 1);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepOne.value[index] = newItem;
    } else {
      arraysStepOne.value.push(newItem);
    }
  }

  console.log('Tableau actuel :', toRaw(arraysStepOne.value));
};

const handleClick = async () => {
  try {
    designation_product_filter.value.length = 0;
    const response = (await productStore.getProductById(
      productId.value,
    )) as any;
    // productId.value = item?.id;
    form_product_step_one.designation = response?.data?.designation;
    form_product_step_one.description = response?.data?.description;
    form_product_step_one.price = response?.data?.price;
    form_product_step_one.SelectRestaurant = response?.data?.restaurant?.id;
    previewUrl.value = String(response?.data?.image?.info?.secureUrl);

    category_product.value = response?.data?.categories.map((it: any) => {
      return it?.category?.id;
    });

    dynamicExtraOptions.value = response?.data?.extraMenus.map((i: any) => {
      return {
        designation: '',
        price: '',
        taxe: '',
        categorie: '',
        description: '',
        image: '',
        nameExtra: i?.title,
        typeQty: '',
        conditionExtra: i?.choiceType,
        required: i?.required,
        extraOptions: i?.options.map((opt: any) => {
          return {
            name: opt?.content,
            price: opt?.price,
          };
        }),
      };
    });

    descriptionPageProduct.value = 'Produit / Modifier ce produit';
    titlePageProduct.value = 'Modification du produit';
    stepOneActive.value = true;
    stepTwoActive.value = false;
    stepThreeActive.value = false;
    stepFourActive.value = false;
    isNewProduct.value = true;
    isReadProduct.value = false;
    isUpdatedProduct.value = true;
  } catch (error) {}
};

const goToNextPage = () => {
  if (isReadProduct.value) {
    handleClick();
  } else if (isUpdatedProduct.value) {
    stepFourActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = true;
    stepOneActive.value = false;
  } else {
    stepFourActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = false;
    stepOneActive.value = false;
    titlePageProduct.value = 'Tous les produits';
    descriptionPageProduct.value = 'Produit / Liste des produits';

    isNewProduct.value = false;
  }
};

const handleSubmitWhenIsRead = async () => {
  try {
    const res = await handleDeleteProduct(productId.value);
    if (res) {
      setTimeout(() => {
        isLoaderLoginFormActivated.value = false;
        document.body.style.overflow = '';
        stepFourActive.value = false;
        isNewProduct.value = false;
      }, 1000);
    }
  } catch (error) {
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      document.body.style.overflow = '';
    }, 1000);
  }
};

const handleSubmitWhenIsUpdatedIsImage = async (
  updateBodyProductPayload: any,
) => {
  try {
    isLoaderLoginFormActivated.value = true;
    const res = await handleUpdateProduct({
      payload: updateBodyProductPayload,
      productId: productId.value,
    });

    if (res) {
      setTimeout(() => {
        isLoaderLoginFormActivated.value = false;
        document.body.style.overflow = '';
        stepFourActive.value = false;
        isNewProduct.value = false;
      }, 1000);
    }
  } catch (error) {
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      document.body.style.overflow = '';
    }, 1000);
  }
};
const handleSubmitWhenIsUpdatedIsImageNot = async (
  buildExtraMenu: any,
  imageUploaoded: any,
) => {
  try {
    isLoaderLoginFormActivated.value = true;
    const res = await handleUploadImage(imageUploaoded);
    if (res && form_product_step_one.image) {
      const updateBodyProductPayload: IUpdateProductBody = {
        designation: form_product_step_one.designation,
        price: Number(form_product_step_one.price),
        restaurantId: form_product_step_one.SelectRestaurant,
        description: form_product_step_one.description,
        imageId: form_product_step_one.image,
        type: 'extra',
        needExtra: true,
        maxQty: 1,
        minQty: 1,
        addInCategories: toRaw(category_product.value),
        removeExtraIds: [],
        addExtra: buildExtraMenu(),
      };

      try {
        const res = await handleUpdateProduct({
          payload: updateBodyProductPayload,
          productId: productId.value,
        });

        if (res) {
          setTimeout(() => {
            isLoaderLoginFormActivated.value = false;
            document.body.style.overflow = '';
            stepFourActive.value = false;
            isNewProduct.value = false;
            isUpdatedProduct.value = false;
          }, 1000);
        }
      } catch (error) {
        setTimeout(() => {
          isLoaderLoginFormActivated.value = false;
          document.body.style.overflow = '';
        }, 1000);
      }
    }
  } catch (error) {
    isLoaderLoginFormActivated.value = true;
  }
};

const handleSubmitWhenIsUpdated = async (
  buildExtraMenu: any,
  imageUploaoded: IProductImage,
) => {
  try {
    const res = await productStore.getProductById(productId.value);
    const data = res?.data as any;
    const buildExtraMenuUpdate = (): ExtraMenuUpdateInterface[] => {
      return dynamicExtraOptions.value.map((extra) => ({
        chooseType: extra.conditionExtra as 'multiple' | 'unique',
        extraType: 'side-dish',
        required: !!extra?.required,
        minQty: Number(extra.valueQty) || null,
        maxQty: Number(extra.valueQty) || null,
        exactQty: Number(extra.valueQty) || null,
        title: extra.nameExtra || null,
        addOption: extra.extraOptions.map((opt) => ({
          type: 'custom',
          content: opt.name || '',
          price: Number(opt.price) || 0,
        })),

        removeOption:
          data?.extraMenus?.length > 0
            ? data.extraMenus.flatMap(
                (element: any) =>
                  element?.options?.map((i: any) => i?.id) || [],
              )
            : [],
      }));
    };

    const removeCategoryIds = data?.categories.filter(
      (item: any) => !toRaw(category_product.value).includes(item?.categoryId),
    );

    const removeExtraIds = data?.extraMenus.filter(
      (item: any) =>
        !dynamicExtraOptions.value.some(
          (extra) => extra.nameExtra === item?.title,
        ),
    );

    const updateBodyProductPayload: any = cleanBody({
      designation: form_product_step_one.designation ?? null,
      price: Number(toDecimal(form_product_step_one.price)) ?? null,
      restaurantId: form_product_step_one.SelectRestaurant ?? null,
      description: form_product_step_one.description ?? null,
      imageId:
        previewUrl.value.startsWith('https') && data?.image && data?.image?.id
          ? data?.image?.id
          : form_product_step_one.image
            ? form_product_step_one.image
            : null,
      type: form_product_step_one.type ?? null,
      needExtra: false,
      maxQty:
        form_product_step_one.valueQty &&
        form_product_step_one.typeQty === 'max'
          ? Number(form_product_step_one.valueQty)
          : 1,
      minQty:
        form_product_step_one.valueQty &&
        form_product_step_one.typeQty === 'min'
          ? Number(form_product_step_one.valueQty)
          : 1,
      addInCategories:
        toRaw(category_product.value).length > 0
          ? toRaw(category_product.value)
          : null,

      removeFromCategories:
        removeCategoryIds && removeCategoryIds.length > 0
          ? removeCategoryIds.map((i: any) => i?.categoryId)
          : null,

      addExtra: data?.extraMenus?.length > 0 ? buildExtraMenu() : null,
      removeExtraIds:
        data?.extraMenus?.length > 0
          ? data.extraMenus.map((i: any) => i?.id)
          : null,
      updateExtra: data?.extraMenus?.length > 0 ? buildExtraMenuUpdate() : null,
    });

    handleSubmitWhenIsUpdatedIsImage(updateBodyProductPayload);
  } catch (error) {
    console.error(error);
  }
};

const handleSubmitDefault = async (
  buildExtraMenu: any,
  imageUploaoded: IProductImage,
) => {
  try {
    isLoaderLoginFormActivated.value = true;
    const res = await handleUploadImage(imageUploaoded);

    if (res && form_product_step_one.image) {
      const productBody: any = cleanBody({
        designation: form_product_step_one.designation ?? null,
        price: Number(toDecimal(form_product_step_one.price)) ?? null,
        restaurantId: form_product_step_one.SelectRestaurant ?? null,
        imageId: form_product_step_one.image ?? null,
        categoryIds:
          toRaw(category_product.value).length > 0
            ? toRaw(category_product.value)
            : null,
        description: form_product_step_one.description ?? null,
        type: form_product_step_one.type ?? null,
        needExtra: false,
        maxQty:
          form_product_step_one.valueQty &&
          form_product_step_one.typeQty === 'max'
            ? Number(form_product_step_one.valueQty)
            : 1,
        minQty:
          form_product_step_one.valueQty &&
          form_product_step_one.typeQty === 'min'
            ? Number(form_product_step_one.valueQty)
            : 1,
        exactQty:
          form_product_step_one.valueQty &&
          form_product_step_one.typeQty === 'exact'
            ? Number(form_product_step_one.valueQty)
            : null,
        ean: form_product_step_one.ean
          ? form_product_step_one.ean.split(',')
          : null,
        pickupTax:
          form_product_step_one.taxe_teakeaway ||
          form_product_step_one.taxte_onsite
            ? cleanBody({
                takeAway: form_product_step_one.taxe_teakeaway
                  ? form_product_step_one.taxe_teakeaway
                  : null,
                dineIn: form_product_step_one.taxte_onsite
                  ? form_product_step_one.taxte_onsite
                  : null,
              })
            : null,

        extraMenu: !buildExtraMenu()?.[0]?.title ? [] : buildExtraMenu(),
      });
      try {
        const res = handleCreateProduct(productBody);
        if (res) {
          setTimeout(() => {
            isLoaderLoginFormActivated.value = false;
            document.body.style.overflow = '';
            stepFourActive.value = false;
            isNewProduct.value = false;
          }, 1000);
        }
      } catch (error) {
        setTimeout(() => {
          isLoaderLoginFormActivated.value = false;
          document.body.style.overflow = '';
        }, 1000);
      }
    }
  } catch (error) {
    console.error('UPLOAD ERROR:', error);
    isLoaderLoginFormActivated.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};

const handleSubmit = async () => {
  const buildExtraMenu = (): ExtraMenuInterface[] => {
    return dynamicExtraOptions.value.map((extra) => ({
      chooseType: extra.conditionExtra as 'multiple' | 'unique',
      extraType: 'side-dish',
      required: extra?.required ? true : false,
      minQty: Number(extra.valueQty) || null,
      maxQty: Number(extra.valueQty) || null,
      exactQty: Number(extra.valueQty) || null,
      title: extra.nameExtra || null,
      option: extra.extraOptions.map((opt) => ({
        type: 'custom' as 'custom' | 'product',
        content: opt.name || '',
        price: Number(opt.price) || 0,
      })),
    }));
  };

  const imageUploaoded: IProductImage = {
    file: file.value,
    restaurantId: form_product_step_one.SelectRestaurant,
    designation: form_product_step_one.designation,
  };
  document.body.style.overflow = 'hidden';
  if (isReadProduct.value) {
    isUpdatedProduct.value = false;
    handleSubmitWhenIsRead();
  } else if (isUpdatedProduct.value) {
    handleSubmitWhenIsUpdated(buildExtraMenu, imageUploaoded);
  } else {
    handleSubmitDefault(buildExtraMenu, imageUploaoded);
  }
};

watchEffect(async () => {
  try {
    const res = await productStore.getProductById(productId.value);
    console.log(res);
  } catch (error) {}
});
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <div class="flex w-full flex-row gap-4">
        <div class="flex-1 space-y-8">
          <TextInput
            :disabled="true"
            @HandleTextInput="(e: Event) => HandleCheckedDesignation(e)"
            required="true"
            v-model="form_product_step_one.designation"
            name="Nom du produit"
            :value="form_product_step_one.designation"
            type="text"
            id="Nom du produit"
            label="Nom du produit"
          />
          <div class="flex w-full flex-row items-center justify-between gap-4">
            <TextInput
              :disabled="true"
              @HandleTextInput="(e: Event) => HandleCheckedPrice(e)"
              class="flex-1"
              required="true"
              v-model="form_product_step_one.price"
              name="Prix du produit"
              :placeholder="form_product_step_one.price"
              :value="form_product_step_one.price"
              type="text"
              id="Prix du produit"
              label="Prix du produit"
            />
          </div>
          <div
            v-show="form_product_step_one.taxe_teakeaway"
            class="flex w-full flex-row items-center justify-between gap-4"
          >
            <div class="flex flex-col gap-2">
              <label
                for="commerce"
                class="text-14px font-tt-medium-Normal leading-normal"
              >
                "Valeur de la TVA pour une commande sur place
                <span class="text-decroissance text-14px leading-normal"
                  >*</span
                >
              </label>

              <select
                id="Entrez la valeur de la TVA"
                v-model="form_product_step_one.taxte_onsite"
                @change="(e: Event) => HandleCheckedDesignation(e)"
                required
                class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
              >
                <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
                <option
                  v-for="value in dataGetTaxeStore?.data"
                  disabled
                  :value="value?.id"
                >
                  {{ value.name }} , {{ value.rate }}%,{{ value.type }}
                </option>
              </select>
            </div>

            <div class="flex flex-col gap-2">
              <label
                for="commerce"
                class="text-14px font-tt-medium-Normal leading-normal"
              >
                Valeur de la TVA pour une commande à emporter
                <span class="text-decroissance text-14px leading-normal"
                  >*</span
                >
              </label>

              <select
                id="Entrez la valeur de la TVA"
                name="Entrez la valeur de la TVA"
                v-model="form_product_step_one.taxe_teakeaway"
                @change="(e: Event) => HandleCheckedDesignation(e)"
                required
                class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
              >
                <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
                <option
                  v-for="value in dataGetTaxeStore?.data"
                  disabled
                  :value="value?.id"
                >
                  {{ value.name }} , {{ value.rate }}%,{{ value.type }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="mx-auto flex w-full max-w-sm flex-col items-center gap-4">
          <div
            v-if="!previewUrl"
            class="border-border-input hover:bg-fond-beige flex w-full cursor-pointer flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed bg-white px-[52px] py-[29px] text-center transition"
          >
            <div
              v-html="IconUploadCloud"
              class="flex items-center justify-center"
            />
            <div
              class="text-14px text-secondary-text font-tt-normal-Normal space-y-1 leading-[19px]"
            >
              <p>Format : <span class="font-medium">PNG</span></p>
              <p>Taille max : <span class="font-medium">5 Mo</span></p>
              <p>Résolution : <span class="font-medium">500 × 500 px</span></p>
            </div>

            <label
              for="file-upload"
              class="font-tt-medium-Normal text-selection text-decoration-skip-ink text-14px cursor-pointer text-center underline transition"
            >
              Charger un fichier
            </label>
          </div>

          <div
            v-else
            class="border-border-input relative h-full w-full overflow-hidden rounded-2xl border border-dashed bg-white shadow-md"
          >
            <img
              :src="previewUrl"
              alt="Preview"
              class="h-full w-full object-contain"
            />
            <!-- <button
              @click="handleDelete"
              class="absolute top-2 right-2 bg-bg-decroissance text-12px text-decroissance cursor-pointer hover:text-white px-2 py-1 rounded hover:bg-red-600"
            >
              Supprimer
            </button> -->
          </div>

          <p v-if="errorMessage" class="text-center text-sm text-red-600">
            {{ errorMessage }}
          </p>
        </div>
      </div>

      <div>
        <div class="flex w-full flex-row items-center justify-between">
          <h1 class="text-grand-text font-tt-medium-Normal text-14px leading-6">
            Ce produit est associé à ces catégorie ou (à la catégorie) :
            <div class="flex w-full flex-row items-center gap-2">
              <p v-for="value in category_product">
                {{
                  dataGetCategories?.data?.find((it) => it?.id === value)
                    ?.designation
                }},
              </p>
            </div>
          </h1>
        </div>
        <div class="flex flex-row flex-wrap items-center gap-2">
          <div
            class="border-border-input p-inline-16px my-4 w-full rounded-2xl border border-solid"
            v-for="(item, index) in dynamicExtraOptions"
            :key="index"
          >
            <div class="flex flex-row items-start gap-2">
              <div class="font-tt-normal-Normal relative -top-[3px] w-full">
                <div>
                  <div
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      Les options de cet extrat
                    </h1>

                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      {{ item?.nameExtra }}
                    </h1>
                  </div>
                  <div
                    v-for="(value, optIndex) in item.extraOptions"
                    :key="optIndex"
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <p class="text-12px text-secondary-text">
                      {{ value?.name }}
                    </p>
                    <p class="text-secondary-text text-12px">
                      {{ formatPrice(Number(value?.price)) }}
                    </p>
                  </div>

                  <div
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <p class="text-12px text-secondary-text">
                      {{ 'Condition' }}
                    </p>

                    <p class="text-12px text-secondary-text">
                      {{ item.conditionExtra }}
                    </p>
                  </div>
                  <div
                    v-if="
                      dataGetCommerces?.data?.find(
                        (item: any) =>
                          item?.id === form_product_step_one?.SelectRestaurant,
                      )
                    "
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <p class="text-12px text-secondary-text">
                      Nom du restaurant
                    </p>

                    <p class="text-12px text-secondary-text">
                      {{
                        dataGetCommerces?.data?.find(
                          (item: any) =>
                            item?.id ===
                            form_product_step_one?.SelectRestaurant,
                        )?.designation
                      }}
                    </p>
                  </div>

                  <div
                    v-show="item?.typeQty"
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <p class="text-12px text-secondary-text">
                      {{ 'Type de Qantité' }}
                    </p>

                    <p class="text-12px text-secondary-text">
                      {{ item?.typeQty }}
                    </p>
                  </div>
                  <div
                    v-show="item?.valueQty"
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <p class="text-12px text-secondary-text">
                      {{ 'Valeur de la  Qantité' }}
                    </p>

                    <p class="text-12px text-secondary-text">
                      {{ item?.valueQty }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isReadProduct && productVariantsList.length > 0"
          class="flex flex-row flex-wrap items-center gap-2"
        >
          <div
            class="border-border-input p-inline-16px my-4 w-full rounded-2xl border border-solid"
          >
            <div class="flex flex-row items-start gap-2">
              <div class="font-tt-normal-Normal relative -top-[3px] w-full">
                <div>
                  <div
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      Variantes du produit
                    </h1>
                  </div>
                  <div
                    v-for="variant in productVariantsList"
                    :key="variant.id"
                    class="flex w-full flex-row items-center justify-between py-1"
                  >
                    <div class="flex flex-row items-center gap-2">
                      <p class="text-12px text-secondary-text">
                        {{ variant.label }}
                      </p>
                      <span
                        v-if="variant.isDefault"
                        class="text-10px bg-fond-beige text-selection rounded px-1 py-0.5"
                      >
                        Défaut
                      </span>
                    </div>
                    <p class="text-12px text-secondary-text">
                      {{ formatPrice(Number(variant.price)) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-2">
          <div
            class="border-border-input p-inline-16px my-4 w-full rounded-2xl border border-solid"
          >
            <div class="flex flex-row items-start gap-2">
              <div class="font-tt-normal-Normal relative -top-[3px] w-full">
                <div>
                  <div
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      Le(s) Ean de ce produit
                    </h1>

                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      {{ form_product_step_one.ean }}
                    </h1>
                  </div>

                  <div
                    class="flex w-full flex-row items-center justify-between"
                  >
                    <h1
                      class="text-14px text-grand-text font-tt-semiBold-Normal"
                    >
                      Le type de ce produit
                    </h1>

                    <p class="text-12px text-secondary-text">
                      {{ form_product_step_one.type }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h1 class="text-grand-text font-tt-medium-Normal text-14px leading-6">
          Description
        </h1>

        <div class="flex h-auto w-full flex-col items-start">
          <div class="lgShadow m-0 w-full">
            <textarea
              disabled
              v-model="form_product_step_one.description"
              @input="(e: Event) => handleCheckDescription(e)"
              class="inputeTextArea text-secondary-text text-littleSize text-text-secondary focus-within:border-text-primary box-border h-[100px] bg-white focus-within:outline-none"
              type="text"
              placeholder="Tape ici..."
              maxlength="315"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-row items-end justify-end gap-4">
      <div @click="goToNextPage">
        <BaseButtonPrimary
          type="button"
          :label="
            isReadProduct
              ? 'Modifier ce produit'
              : isUpdatedProduct
                ? 'Page précédente'
                : 'Voir tous les produits'
          "
          style_of_btn="secondary_color_of_btn "
          class="text-grand-text"
        />
      </div>
      <BaseButtonPrimary
        :isClicked="isLoaderLoginFormActivated"
        type="submit"
        :label="
          isReadProduct
            ? 'Supprimer ce produit'
            : isUpdatedProduct
              ? 'Modifier ce produit'
              : 'Sauvegarder ce produit'
        "
        style_of_btn="primary_color_of_btn "
        class="text-white"
      />
    </div>
  </form>
</template>
